<script>
	let formInputData = {
        name: '',
        alias: '',
        location: '',
        email: '',
        phone: '',
        date: '',
        dontUseName: false,
    }

    function handleSubmit(event) {
        event.preventDefault();
        
        const QUERY = new URLSearchParams(formInputData).toString();

        window.open(`/german.html?${QUERY}`, '_blank');
        postData(`https://photography-contract.pottkinder.dev/german.html?${QUERY}`);
    }

    function postData(url) {
        const data = {
            content_url: url,
        };

        // console.log(JSON.stringify(data));
        // console.log(typeof JSON.stringify(data));

        fetch('https://pdf.staging.pottkinder.dev/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then((data) => {
            console.log('Response:', data);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
</script>

<!-- <form id='contract' name='contract' action='https://pdf.pottkinder.dev/' method='POST'> -->
<form id='contract' name='contract' on:submit={handleSubmit}>
    <label class='formLabel' for='name' form='contract'>Name: </label>
    <input type='text' class='formInput' id='name' name='name' form='contract' bind:value={formInputData.name} />
    <label class='formLabel' for='alias' form='contract'>Künstlername: </label>
    <input type='text' class='formInput' id='alias'  name='alias' form='contract' bind:value={formInputData.alias} />
    <label class='formLabel' for='location' form='contract'>Wohnhaft: </label>
    <input type='text' class='formInput' id='location'  name='location' form='contract' bind:value={formInputData.location} />
    <label class='formLabel' for='email' form='contract'>Email: </label>
    <input type='email' class='formInput' id='email'  name='email' form='contract' bind:value={formInputData.email} />
    <label class='formLabel' for='phone' form='contract'>Handy: </label>
    <input type='tel' class='formInput' id='phone'  name='phone' form='contract' bind:value={formInputData.phone} />
    <div style='display: grid;grid-auto-flow: column;justify-content: start;align-items: baseline;gap: 0.5rem;'>
        <input type='checkbox' class='formInput' id='dontUseName' name='dontUseName' form='contract' bind:checked={formInputData.dontUseName} />
        <label class='formLabel' for='dontUseName' form='contract'>Es soll kein Name verwendet werden.</label>
    </div>
    <label class='formLabel' for='date' form='contract'>Das Shooting findet statt am: </label>
    <input type='date' class='formInput' id='date'  name='date' form='contract' bind:value={formInputData.date} />
    <input type='submit' form='contract' value='Generieren' />
</form>

<style>

</style>